import Component from '@glimmer/component';
import { type EventInfoComponentArgs } from 'donor-elf-web/components/event/index';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import V2TaskModel from 'donor-elf-web/models/v2-task';
import AddSomethingModal, {
  type TaskAddedArgs,
} from 'donor-elf-web/services/add-something-modal';
import TaskService from 'donor-elf-web/services/task-service';
import TaskInfo from 'donor-elf-web/components/task/info';
import lifecycle from 'donor-elf-web/modifiers/lifecycle';
import isPresent from 'donor-elf-web/helpers/is-present';
import momentFromNow from 'ember-moment/helpers/moment-from-now';
import { on } from '@ember/modifier';
import formatDate from 'donor-elf-web/helpers/format-date';

export default class EventInfoUnthankedDonorComponent extends Component<EventInfoComponentArgs> {
  @service declare addSomethingModal: AddSomethingModal;
  @service declare taskService: TaskService;

  @tracked createdThankTask?: V2TaskModel;
  addTaskSubsciptionToken?: string;

  handleCreateTask = () => {
    if (this.addTaskSubsciptionToken == null) {
      this.addTaskSubsciptionToken =
        this.addSomethingModal.subscribeToTaskAdded(
          this.handleTaskAddedFromAddModal,
        );
    }
    this.addSomethingModal.open({
      type: 'task',
      taskOptions: {
        contactId: this.args.eventModel.contactId,
        actionLabel: 'Thank',
        hideAddAnother: true,
      },
    });
  }

  handleTaskAddedFromAddModal = (_message: string, data: TaskAddedArgs) => {
    if (
      data.task.contactId === this.args.eventModel.contactId &&
      data.task.actionId === this.taskService.actionsByLabel['Thank']?.id
    ) {
      this.createdThankTask = data.task;
    }
  }

  handleThankTaskDeleted = () => {
    this.createdThankTask = undefined;
  }

  onLifecycle = () => {
    return () => {
      if (this.addTaskSubsciptionToken) {
        this.addSomethingModal.unsubscribeWithToken(this.addTaskSubsciptionToken);
        this.addTaskSubsciptionToken = undefined;
      }
    }
  }

  <template>
    <div {{lifecycle this.templateWillDestroy}}>
      {{#if (isPresent this.createdThankTask)}}
        <p>
          The following thank task has been created, and this news feed event will
          be removed.
        </p>
        <div class='mb-3'>
          <TaskInfo
            @task={{this.createdThankTask}}
            @onTaskDeleted={{this.handleThankTaskDeleted}}
            class='d-inline-block'
          />
        </div>
      {{else}}
        <div>
          {{#if @eventModel.custom.first_gift}}
            They have not been thanked for their first gift.
          {{else if (isPresent @eventModel.custom.gift_interval)}}
            Gift Interval
          {{else if (isPresent @eventModel.custom.last_thank_date)}}
            They were last thanked
            {{momentFromNow @eventModel.custom.last_thank_date}}
            <span class='font-weight-light text-muted'>(on
              {{formatDate @eventModel.custom.last_thank_date}})</span>
          {{else}}
            They have not been thanked yet.
          {{/if}}
        </div>
        <button
          {{on 'click' this.handleCreateTask}}
          class='btn btn-xs btn-outline-brand mt-2'
          type='button'
        >
          Create Thank Task
        </button>
      {{/if}}
    </div>
  </template>
}
